import { App } from '@capacitor/app';
import { StatusBar } from '@capacitor/status-bar';
import { isNative } from './runtime.ts';

export type NativeBridgeOptions = {
  onResume?: () => void;
};

export function initNativeBridge(options: NativeBridgeOptions = {}): void {
  if (!isNative()) return;
  void StatusBar.hide().catch(() => undefined);

  if (options.onResume) {
    void App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) options.onResume?.();
    });
  }
}
